export const USER_FUNCTION_NAMES = {
  GET_USER_INFO: 'get_user_info',
  ADD_ADDITIONAL_EMAIL: 'add_additional_email',
  VERIFY_ADDITIONAL_EMAIL: 'verify_additional_email',
  REMOVE_ADDITIONAL_EMAIL: 'remove_additional_email',
  REMOVE_EMAIL_VERIFICATION: 'remove_email_verification',
}

export const VERIFICATION_CODE_LENGTH = 6

/** `status` on the POST /user/functions envelope. */
export const USER_FUNCTION_STATUS = {
  SUCCESS: 'success',
  VERIFICATION_SENT: 'verification_sent',
  INVALID: 'invalid',
  EXPIRED: 'expired',
}

export const ADDITIONAL_EMAIL_STATUS = {
  VERIFIED: 'verified',
  PENDING: 'pending',
}

export const ADDITIONAL_EMAIL_CONFIRM_TEXTS = {
  REMOVE_PENDING: {
    title: 'Remove email address',
    icon: 'trash',
    confirmText: 'Remove',
    confirmColor: 'negative',
    message: (email) =>
      `Remove ${email}? The code we sent will stop working, and this address will not be added.`,
  },
  REMOVE_VERIFIED: {
    title: 'Remove email address',
    icon: 'trash',
    confirmText: 'Remove',
    confirmColor: 'negative',
    message: (email) =>
      `Remove ${email} from your account? You will no longer be able to use this address for integrations.`,
  },
}
